<template>
    <div class="help-pane"
         v-if="helpText">

        <b-button class="help-pane__button" @click="togglePane">
            <b-icon-question-circle/>
        </b-button>
        <b-sidebar right
                   id="help-sidebar"
                   class="help-pane__content"
                   :title="$i18n.gt('HEADING_HELP')"
                   :no-close-on-route-change="true"
                   :visible="paneVisible">
            <div class="px-3 py-2 sidebar-content">
                <div v-html="helpText"></div>
                <div v-for="(helpVimeoId, index) in helpVimeoIds" :key="index">
                    <div v-if="helpVimeoId.title" v-html="helpVideoTitle(helpVimeoId)"></div>

                    <div style="padding: 177.78% 0 0 0;position:relative;" class="mb-5"
                         v-if="helpVimeoId && helpVimeoId.orient !== 'landscape'">

                        <iframe
                            :src="`https://player.vimeo.com/video/${helpVimeoId.id}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`"
                            frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen
                            style="position:absolute;top:0;left:0;width:100%;height:100%;"
                            title="Help Video">
                        </iframe>
                    </div>

                    <div style="padding: 56.25% 0 0 0;position:relative;" class="mb-5"
                         v-if="helpVimeoId && helpVimeoId.orient === 'landscape'">

                        <iframe
                            :src="`https://player.vimeo.com/video/${helpVimeoId.id}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`"
                            frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen
                            style="position:absolute;top:0;left:0;width:100%;height:100%;"
                            title="Help Video">
                        </iframe>
                    </div>

                </div>

            </div>
            <b-button to="/support">{{ $i18n.gt('HELP_CONTACT_SUPPORT') }}</b-button>
        </b-sidebar>

    </div>
</template>

<script>
    import Vue from 'vue'
    import * as _ from 'lodash'

    /**
     * Renders a help button on the page, which activates a Help sidebar with content
     * specified via a translation key in the route meta configuration
     */
    export default Vue.extend({
        name: 'HelpPane',
        computed: {
            helpPane () {
                return this.$store.state.helpPane
            },
            helpVimeoIds() {
                if (this.$route.meta.help !== 'HOME') {
                    return this.$route.meta.helpVimeoIds
                } else {
                    if (this.$user.roleIs('PRACTITIONER')) {
                        let videos = []
                        if (this.$auth.isPracticeManager()) {
                            videos.push({title: 'VIDEO_IMPORT_PATIENTS', id: '561522561', orient: 'landscape'})
                        }
                        if (this.$auth.canManageCompanyPlans()) {
                            videos.push({title: 'VIDEO_MANAGE_RESOURCES', id: '561600827', orient: 'landscape'})
                            videos.push({title: 'VIDEO_HEALTH_PLANS', id: '562941484', orient: 'landscape'})

                        }
                        return videos
                    }
                }
                return []
            },
            helpKey() {
                const key = this.$route.meta.help
                if (key === 'HOME') {
                    if (this.$user.roleIs('ADMIN')) {
                        return 'HOME_ADMIN'
                    } else if (this.$user.roleIs('PARTICIPANT')) {
                        return 'HOME_PARTICIPANT'
                    } else if (this.$user.roleIs('PRACTITIONER')) {
                        if (this.$auth.isPracticeManager()) {
                            return 'HOME_PRACTICE_MANAGER'
                        } else {
                            return 'HOME_PRACTITIONER'
                        }
                    } else {
                        //if (this.$user.noLoggedInUser())
                        return 'HOME_ANONYMOUS'
                    }
                } else {
                    return key
                }
            },
            helpText() {
                const key = this.helpKey
                if (key) {
                    return this.$i18n.gt(`HELP_${key}`)
                } else {
                    return null
                }
            },
            paneVisible: {
                get () {
                    return this.$store.state.helpPane
                },
                set (val) {
                    // save & persist
                    this.$store.commit('set',
                      val
                        ? { helpPane: true, chatPane: false, videoPane: false }
                        : { helpPane: false })
                    this.$store.dispatch('save')
                }
            },
        },
        methods: {
            togglePane() {
                this.paneVisible = !this.paneVisible
            },
            helpVideoTitle(id) {
                const key = id.title
                if (key) {
                    return this.$i18n.gt(`HELP_${key}`)
                } else {
                    return null
                }

            }
        }
    })
</script>

<style lang="scss">

    .help-pane {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 2;

        header.b-sidebar-header > .close {
            height: 32px;
            width: 32px;
        }

        .b-sidebar {
          height: calc(100vh - 44px);
        }

        .btn {
            border-radius: 5px 0 0 0;
            position: absolute;
            right: 0;
            bottom: 0;
            padding: 7px;

            &:active, &:focus {
                background-color: var(base-color);
            }

            svg {
                font-size: 30px !important;
            }
        }

        .sidebar-content {
            height: 100%;
            overflow-y: scroll;
        }

        button.close {
            border: solid 1px var(--blue-lighten-30);
            background-color: #fff;
            padding: 3px;
            border-radius: 50%;
            cursor: pointer;
            opacity: 1;

            svg {
                color: var(--blue-lighten-30);
            }

            &:hover {
                background-color: var(--btn-bg-hover);
                border-color: var(--btn-bg-hover);
                opacity: 1 !important;

                svg {
                    color: #fff !important;
                }
            }
        }
    }

    #help-sidebar {
        box-shadow: 0 0 20px rgba(0, 0, 0, .1);
        border-left: solid 1px var(--border-color);
      background-color: var(--accent-color-lighten-40-opaque) !important;
        height: calc(100vh - 44px);
    }

</style>
